import React, { useEffect, useState } from "react";
import InnerHead from "../components/InnerHead";
import Header from "../components/Header";
import ContactUs from "../components/ContactUs";
import Footer from "../components/Footer";
import { client } from "../config/prismic";

const Past = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await client.getByType("past_conference");
      setData(response.results.map((result) => result.data)); // Map to simplify access to conference data
    };
    fetchData();
  }, []);

  if (!data) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }
  return (
    <div>
      <Header />
      <InnerHead />
      <div
        className="section-title text-center position-relative py-3 my-2 mx-auto"
        style={{ maxWidth: "600px" }}
      >
        <h5 className="fw-bold text-primary text-uppercase">
          Past Conferences
        </h5>
        <h2 className="mb-0">Past Conferences</h2>
      </div>
      <div className="container my-5">
        {data.map((conferenceData, index) =>
          conferenceData.collection.map((conference, confIndex) => (
            <div key={`${index}-${confIndex}`} className="card shadow-lg my-4">
              <div className="card-body text-center">
                <h3 className="card-title mb-3">{conference.title[0]?.text}</h3>
                <p className="card-text">
                  <strong>Venue:</strong> {conference.venue[0]?.text}
                </p>
                <p className="card-text">
                  <strong>Date:</strong> {conference.date[0]?.text}
                </p>
                <p className="card-text">{conference.description[0]?.text}</p>
                <p className="card-text">
                  <strong>{conference.acroynm[0]?.text}</strong>
                </p>
                <p className="card-text">
                  <strong>IEEE Catalog Number:</strong>{" "}
                  {conference.catalog_number[0]?.text}
                </p>

                {conference.proceedings_link[0]?.text && (
                  <a
                    href={conference.proceedings_link[0].text}
                    className="btn btn-primary mt-4 mx-2"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Proceedings Link
                  </a>
                )}
              </div>
            </div>
          ))
        )}
      </div>
      <ContactUs />
      <Footer />
    </div>
  );
};

export default Past;
